import React from 'react';
import tpl from '../templates/expressEnergy.jsx';
import AExpressModel from '../../../Business/Models/aexpress.m';
import BaseNewCardView from '../../../Cards/views/BaseNewCardView.js';
import {apiback} from '../../../../config.js';

export default class extends BaseNewCardView {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            search_by: ['/express_energy'],
            mode: 'express-energy-standard'
        };

        this.toggleMode = this.toggleMode.bind(this);
    }

    shouldFetchData() {
        return false;
    }

    componentDidMount() {
        super.componentDidMount();
        document.addEventListener('switchCalcMode', this.toggleMode);
        const modelPromise = fetch(apiback('EXPRESS_ENERGY_CALC'))
            .then(res => res.json())
            .then(json => {
                const list = Object.keys(json.data);
                const model = new AExpressModel(json.data, list, this.state.mode);

                this.setState({model});
            });

        const widgetsPromise = this.widgetsHelper.getWidgets.call(this);

        Promise.all([modelPromise, widgetsPromise]).then(() => {
            this.handleScrollFromQuery();
        });
    }

    componentWillUnmount() {
        document.removeEventListener('switchCalcMode', this.toggleMode);
    }

    toggleMode(event) {
        const {mode} = event.detail;

        this.setState({mode});
        this.state.model.changeField('currentName', mode);
        if (mode === 'express-energy-collateral') {
            this.state.model.changeField('creditSum', '1000000');
            this.state.model.changeField('loanTerm', '30');
        }
    }

    scrollConfig() {
        return [{param: 'calc', selector: '.calculator-new'}];
    }

    static displayName = 'Business.Views.ExpressEnergy';
}
